import { FaderBaseView } from '../es6/views/fader/fader-base-view'

/**
 * Глобальный вид затемнения страницы.
 * @type {FaderBaseView}
 */
export const fader = new FaderBaseView()
